import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOurExpertise, IOurExpertiseInitialState } from "./ourExpertiseModel";
import {
  ActiveInactiveOurExpertise,
  createOurExpertise,
  deleteOurExpertise,
  getAllActiveOurExpertises,
  getAllOurExpertises,
  getOurExpertiseByID,
  updateOurExpertise,
} from "./services/ourExpertise.services";

const initialState: IOurExpertiseInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  OurExpertiseList: [],
  OurExpertiseID: null,
  OurExpertiseDetail: {
    Title: "",
    Description: "",
    IsActive: 1,
  },
};

const ourExpertiseSlice = createSlice({
  name: "ourExpertise",
  initialState,
  reducers: {
    clearOurExpertiseDetails: (state) => {
      state.OurExpertiseDetail = initialState.OurExpertiseDetail;
    },
    setOurExpertiseID: (state, action) => {
      state.OurExpertiseID = action.payload;
    },
    clearOurExpertiseID: (state) => {
      state.OurExpertiseID = initialState.OurExpertiseID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllOurExpertises.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllOurExpertises.fulfilled,
      (state, action: PayloadAction<IOurExpertise[]>) => {
        state.loading = false;
        state.OurExpertiseList = action.payload || [];
      }
    );
    builder.addCase(getAllOurExpertises.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.OurExpertiseList = [];
    });
    builder.addCase(createOurExpertise.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createOurExpertise.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createOurExpertise.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateOurExpertise.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateOurExpertise.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateOurExpertise.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteOurExpertise.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteOurExpertise.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteOurExpertise.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getOurExpertiseByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getOurExpertiseByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.OurExpertiseDetail = action.payload;
    });
    builder.addCase(getOurExpertiseByID.rejected, (state, action) => {
      state.formLoading = false;
      state.OurExpertiseDetail = initialState.OurExpertiseDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveOurExpertises.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveOurExpertises.fulfilled,
      (state, action: PayloadAction<IOurExpertise[]>) => {
        state.loading = false;
        state.OurExpertiseList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveOurExpertises.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.OurExpertiseList = [];
    });
    builder.addCase(ActiveInactiveOurExpertise.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveOurExpertise.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveOurExpertise.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearOurExpertiseDetails,
  clearOurExpertiseID,
  setOurExpertiseID,
} = ourExpertiseSlice.actions;
export default ourExpertiseSlice.reducer;
